import styled from "styled-components"

export const OffersImage = styled.img `

    width: 133px;
    height: 118px;

`